export default __webpack_public_path__ + "static/media/IMG_0382-2.5b3fbaa1.jpg";